<template>
    <div class="fab-container" id="match-filter-btn">
        <div class="button iconbutton" data-bs-toggle="modal" data-bs-target="#filerConditionModal" @click="loadFilterCondition" onclick="gtag('event', 'app-open-filter-match', {'event_category': 'button','event_label': 'app-open-filter-match'});">
            <!-- <i class="fa-solid fa-bars"></i> -->
            <!-- <i class="fa-solid fa-magnifying-glass"></i> -->
            <font-awesome-icon :icon="['fas', 'magnifying-glass']" id="filter-icon" />
        </div>
    </div>

    <div class="modal fade modal-dialog-scrollable" id="filerConditionModal" tabindex="-1"
        aria-labelledby="filerConditionModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="filerConditionModalLabel">絞り込み条件</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">


                    <table class="table table-sm table-borderless">
                        <tr>
                            <td style="line-height: 0.9em;">
                                <b>グレード：</b><br>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="btn-check" id="grade-6" autocomplete="off" v-model="filterConditionGrade" value="6">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-6">６年</label>
                                    <input type="checkbox" class="btn-check" id="grade-5" autocomplete="off" v-model="filterConditionGrade" value="5">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-5">５年</label>
                                    <input type="checkbox" class="btn-check" id="grade-4" autocomplete="off" v-model="filterConditionGrade" value="4">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-4">４年</label>
                                    <input type="checkbox" class="btn-check" id="grade-3" autocomplete="off" v-model="filterConditionGrade" value="3">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-3">３年</label>
                                    <input type="checkbox" class="btn-check" id="grade-2" autocomplete="off" v-model="filterConditionGrade" value="2">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-2">２年</label>
                                    <input type="checkbox" class="btn-check" id="grade-1" autocomplete="off" v-model="filterConditionGrade" value="1">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="grade-1">１年</label>
                                    <br><br>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="line-height: 0.9em;">
                                <b>性別・混合：</b><br>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="btn-check" id="gender-m" autocomplete="off" v-model="filterConditionGender" value="m">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="gender-m">男子(M)</label>
                                    <input type="checkbox" class="btn-check" id="gender-w" autocomplete="off" v-model="filterConditionGender" value="w">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="gender-w">女子(W)</label>
                                    <!-- <input type="checkbox" class="btn-check" id="gender-x" autocomplete="off" v-model="filterConditionGender" value="x">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="gender-x">混合(X)</label> -->
                                    <input type="checkbox" class="btn-check" id="gender-n" autocomplete="off" v-model="filterConditionGender" value="n">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="gender-n">なし(N)</label><br><br>

                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="line-height: 0.9em;">
                                <b><span v-bind:class="{'text-muted': isDisabledConditionGroup === true, 'text-dark': isDisabledConditionGroup === false}">グループ：</span></b><br>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="btn-check" id="group-a" autocomplete="off" v-model="filterConditionGroup" value="a" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-a">A</label>
                                    <input type="checkbox" class="btn-check" id="group-b" autocomplete="off" v-model="filterConditionGroup" value="b" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-b">B</label>
                                    <input type="checkbox" class="btn-check" id="group-c" autocomplete="off" v-model="filterConditionGroup" value="c" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-c">C</label>
                                    <input type="checkbox" class="btn-check" id="group-d" autocomplete="off" v-model="filterConditionGroup" value="d" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-d">D</label>
                                    <input type="checkbox" class="btn-check" id="group-e" autocomplete="off" v-model="filterConditionGroup" value="e" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-e">E</label>
                                    <input type="checkbox" class="btn-check" id="group-f" autocomplete="off" v-model="filterConditionGroup" value="f" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-f">F</label>
                                    <input type="checkbox" class="btn-check" id="group-g" autocomplete="off" v-model="filterConditionGroup" value="g" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-g">G</label>
                                    <input type="checkbox" class="btn-check" id="group-h" autocomplete="off" v-model="filterConditionGroup" value="h" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-h">H</label>
                                    <!-- 
                                    <input type="checkbox" class="btn-check" id="group-i" autocomplete="off" v-model="filterConditionGroup" value="i" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-i">I</label> -->
                                    <br>
                                    <input type="checkbox" class="btn-check" id="group-ta" autocomplete="off" v-model="filterConditionGroup" value="ta" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-ta">Ta</label>
                                    <input type="checkbox" class="btn-check" id="group-tb" autocomplete="off" v-model="filterConditionGroup" value="tb" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-tb">Tb</label>
                                    <input type="checkbox" class="btn-check" id="group-tc" autocomplete="off" v-model="filterConditionGroup" value="tc" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-tc">Tc</label>
                                    <input type="checkbox" class="btn-check" id="group-td" autocomplete="off" v-model="filterConditionGroup" value="td" v-bind:disabled="isDisabledConditionGroup">
                                    <label class="me-1 mt-1 btn btn-outline-primary" for="group-td">Td</label>     
                                    <br><br>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="line-height: 0.9em;">
                                <b>チーム：</b><br>
                                <div class="form-check form-check-inline">
                                    <select class="form-select" aria-label="Default select example" id="teamSelected" v-model="filterConditionTeam">
                                        <option value="">全チーム</option>
                                        <option v-for="(team, index) in teamList" :value="index">{{ team.name }}</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm filter-btn" data-bs-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary btn-sm filter-btn filter-reset-btn"
                        @click="resetFilterCondition">全てクリア</button>
                    <button type="button" class="btn btn-primary btn-sm filter-btn" data-bs-dismiss="modal" @click="saveFilterCondition" onclick="gtag('event', 'app-run-filter-match', {'event_category': 'button','event_label': 'app-run-ilter-match'});">この条件で絞り込む</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
const emit = defineEmits(["doRealtimeSearch"])
const teamList = ref([]);
const filterConditionGrade = ref([]);
const filterConditionGender = ref([]);
const filterConditionGroup = ref([]);
const filterConditionTeam = ref([]);

onMounted(() => {
    teamList.value = JSON.parse(localStorage.getItem("teams"))
    filterConditionTeam.value = ""
})

const isDisabledConditionGroup = computed(() => {
    // if (filterConditionGrade.value.length != 0 || filterConditionGender.value.length != 0) {
    if (filterConditionGender.value.length != 0) {
        return false // activate the checkbox
    } else {
        filterConditionGroup.value = [] // clear up group condition
        return true // disable the checkbox
    }
})

const resetFilterCondition = () => {
    let elements = document.getElementsByClassName("btn-check");
    for (let i = 0; i < elements.length; i++) {
        elements[i].checked = false;
    }
    document.getElementById("teamSelected").value = "";
    filterConditionGrade.value = []
    filterConditionGender.value = []
    filterConditionGroup.value = []
    filterConditionTeam.value = ""
}

const loadFilterCondition = () => {
    var localData = localStorage.getItem("filterConditionGrade");
    if (localData) {
        filterConditionGrade.value = JSON.parse(localData);    
    }
    localData = localStorage.getItem("filterConditionGender")
    if (localData) {
        filterConditionGender.value = JSON.parse(localData)
    }
    localData = localStorage.getItem("filterConditionGroup")
    if (localData) {
        filterConditionGroup.value = JSON.parse(localData)    
    }
    localData = localStorage.getItem("filterConditionTeam")
    if (localData) {
        filterConditionTeam.value = JSON.parse(localData)
    }
}

const saveFilterCondition = () => {
    localStorage.setItem("filterConditionGrade", JSON.stringify(filterConditionGrade.value))
    localStorage.setItem("filterConditionGender", JSON.stringify(filterConditionGender.value))
    localStorage.setItem("filterConditionGroup", JSON.stringify(filterConditionGroup.value))
    localStorage.setItem("filterConditionTeam", JSON.stringify(filterConditionTeam.value))
    emit('doRealtimeSearch', filterConditionGender) // ToDo Emit doesn't work
}
</script>

<style scoped>
.fab-container {
    position: fixed;
    bottom: 80px;
    right: 25px;
    cursor: pointer;
    z-index: 8;
}

.iconbutton {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: #3D8BFD;
    box-shadow: 5px 5px 5px #aaaaaa;
}

#filter-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 20px;
    color: white;
    padding: 15px;
}

.button {
    width: 50px;
    height: 50px;
    background: #0d6efd;
}

.options {
    list-style-type: none;
    position: absolute;
    bottom: 50px;
    right: 0;
}

.options li {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
}

.btn-label {
    white-space: nowrap;
    padding: 2px 5px;
    margin-right: 10px;
    align-self: center;
    user-select: none;
    background-color: black;
    color: white;
    border-radius: 3px;
    box-shadow: 5px 5px 5px #aaaaaa;
}

.filter-reset-btn:focus {
    color: #0d6efd;
    background-color: white;
}

@media screen and (max-width: 768px) {
    .filter-btn {
        padding: 8px;
    }
}</style>